import {DXCurrentValue, DXVariable} from "@/types";

export function sortGroupsAndVariables(groups: {[key: string]: DXCurrentValue[] | DXVariable[]}) {
	const sortedGroups: {
		[key: string]: DXCurrentValue[] | DXVariable[];
	} = {};
	const sortedKeys = Object.keys(groups).sort((a, b) => {
		if (a.toLowerCase() === "main") return -1; // Place the main group to the first place
		if (b.toLowerCase() === "main") return 1;
		return a.localeCompare(b);
	});

	sortedKeys.forEach((idx) => {
		if (idx.toLowerCase() === "main") {
			sortedGroups[idx] = groups[idx].sort((a, b) => a.mainrank - b.mainrank);
		} else {
			sortedGroups[idx] = groups[idx].sort((a, b) => a.rank - b.rank);
		}
	});

	return sortedGroups;
}

export function regroupWithMainRank(
	groups: Record<
		string,
		DXVariable[]
	>
): Record<
	string,
	DXVariable[]
> {
	const regroupedWithMain: Record<
		string,
		DXVariable[]
	> =
		{}

	Object.values(
		groups
	).forEach(
		(
			list
		) => {
			list.forEach(
				(
					v
				) => {
					const group =
						v.mainrank >
						0
							? "main"
							: v.group
					if (
						!regroupedWithMain[
							group
						]
					) {
						regroupedWithMain[
							group
						] =
							[]
					}
					regroupedWithMain[
						group
					].push(
						v
					)
				}
			)
		}
	)

	return regroupedWithMain
}

export function groupVariablesByGroupName(
	variables: DXVariable[]
): Record<
	string,
	DXVariable[]
> {
	const groups: Record<
		string,
		DXVariable[]
	> =
		{}
	variables
		.sort(
			(
				a,
				b
			) =>
				a.name.localeCompare(
					b.name
				)
		)
		.forEach(
			(
				variable
			) => {
				const group =
					variable.group
				if (
					!groups[
						group
					]
				) {
					groups[
						group
					] =
						[]
				}
				groups[
					group
				].push(
					variable
				)
			}
		)
	return groups
}
